
import { CompanyInfo } from "@/types/company";
import http from "./http";
import { AxiosResponse } from "axios";
import { ENCRYPT_APIS } from "./encypet_apis";

export async function getCompanyInfo(): Promise<CompanyInfo[]> {
  try {
    const url = ENCRYPT_APIS.getCompanyInfo;
    const res = await http.get<Array<CompanyInfo>>(url);
    return res.data;
  } catch (e) {
    console.log('>>> getCompanyInfo error: ', e);
    return [];
  }
}

export async function choiceCompany(identityId: string): Promise<AxiosResponse | undefined> {
  try {
    const res = await http.post("/api/auth/user/company/choice", { identityId });
    console.log(">>> choiceCompany res: ", res);
    return res;
  } catch (e) {
    console.log(">>> choiceCompany error: ", e);
    return undefined;
  }
}